import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.971 3.292c-.356-.036-.682.182-1.335.618l-2.473 1.648c-.843.562-1.264.843-1.714 1.067a8 8 0 0 1-1.031.427c-.477.16-.974.26-1.967.458l-.955.19-.006.002a1 1 0 0 0-.625 1.547l.004.006.018.026a35 35 0 0 0 3.682 4.472.75.75 0 0 0-.6.217l-4.5 4.5a.75.75 0 1 0 1.061 1.06l4.5-4.5a.75.75 0 0 0 .217-.6 35 35 0 0 0 4.472 3.683l.027.018.005.004a1 1 0 0 0 1.547-.625l.001-.006.191-.955c.199-.993.298-1.49.458-1.966q.177-.532.427-1.032c.224-.45.505-.871 1.067-1.714l1.648-2.473c.436-.653.654-.98.618-1.335-.035-.356-.312-.633-.867-1.188l-2.682-2.682c-.555-.555-.832-.832-1.188-.867",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }